import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import React from "react";
import { Controller } from "react-hook-form";
import { isNullishCoalesce } from "typescript";

interface SelectFieldProps {
  fieldName: string;
  label?: string;
  fullWidth?: boolean;
  control?: any;
  error?: boolean;
  helperText?: any;
  defaultValue?: string | boolean | null | number;
  options: any[];
  variant?: "filled" | "outlined" | "standard";
  valueKey: string;
  labelKey: string;
  disabled?: boolean;
  isActiveDropDown?: boolean;
  onFieldChange?: (event: React.ChangeEvent<{ value: unknown }>) => void;
  other?: Object;
  labelManipulateFn?: any;
  style?: object;
  onChangeFunction?: any;
}

const SelectField: React.FC<SelectFieldProps> = ({
  fieldName,
  control,
  label,
  error,
  helperText,
  fullWidth,
  defaultValue,
  options,
  variant,
  valueKey,
  labelKey,
  disabled,
  isActiveDropDown = false,
  onFieldChange,
  other,
  labelManipulateFn,
  style,
  onChangeFunction,
}) => {
  return (
    <FormControl
      fullWidth={fullWidth || true}
      variant={variant || "filled"}
      error={error}
      disabled={disabled ?? false}
      sx={{
        "& .MuiInputBase-root": {
          height: 38,
        },
        "& .MuiInputLabel-formControl": {
          top: "-9px",
        },
        ...style,
      }}
    >
      {!!label && <InputLabel>{label}</InputLabel>}
      <Controller
        name={fieldName}
        control={control}
        defaultValue={defaultValue || ""}
        render={({ field }) => (
          <Select
            {...field}
            value={field.value}
            onChange={(event) => {
              onFieldChange && onFieldChange(event.target.value);
              field.onChange(event);
            }}
            sx={{
              backgroundColor: "#f2f4fb",
              "& fieldset": {
                borderColor: "#ebebec",
              },
            }}
            {...(label && { label })}
            {...other}
            //needed for later
            // sx={{
            //   ...(isActiveDropDown && {
            //     color: field?.value === "true" ? "success.main" : "error.main",
            //   }),
            // }}
          >
            <MenuItem value={""}>
              <em>None</em>
            </MenuItem>
            {options?.map((e, i) => (
              <MenuItem
                key={i}
                value={e[valueKey]}
                onClick={() => {
                  onChangeFunction?.(e);
                }}
                //needed for later
                // sx={{
                //   ...(isActiveDropDown && {
                //     color: e?.color,
                //   }),
                // }}
              >
                {labelManipulateFn
                  ? labelManipulateFn(e[labelKey])
                  : e[labelKey]}
              </MenuItem>
            ))}
          </Select>
        )}
      />
      {error && (
        <FormHelperText sx={{ color: "secondary.main" }}>
          {helperText}
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default SelectField;
